import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  documentToDeleteID: null,

}

const store = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    setDocumentToDeleteID: (state, { payload }) => {
      if (payload) {
        state.documentToDeleteID = payload
      } else {
        state.documentToDeleteID = null
      }
    },
  },
})

export default store
